export default "__VITE_ASSET__DRZj4EAe__"